module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Contract representatives","newLink":"+ Add representative","notFound":"Representatives not found"},"et":{"title":"Contract representatives","newLink":"+ Add representative","notFound":"Representatives not found"},"ru":{"title":"Contract representatives","newLink":"+ Add representative","notFound":"Representatives not found"}}')
  delete Component.options._Ctor
}
